import { GQLContentRichTextFragment } from '@theprintbar/graphql';
import { RichText } from '@theprintbar/ui';

interface CTATextProps {
	text?: string | GQLContentRichTextFragment | null;
	className?: string;
	useH3?: boolean;
}
export function CTAText({ text, className, useH3 }: CTATextProps) {
	if (!text) return null;

	return (
		<div className={className}>
			{typeof text === 'string' ? <>{useH3 ? <h3>{text}</h3> : <p>{text}</p>}</> : <RichText content={text.content} />}
		</div>
	);
}
